import { useState, useEffect, Fragment } from 'react';
import { Combobox } from '@headlessui/react';
import { Transition } from '@headlessui/react';

function ComboboxMultiSelectAPI({
  getData,
  getDisplay,
  getId,
  selectedValues,
  onChange,
  placeholder = 'Digita per cercare...'
}) {
  const [query, setQuery] = useState('');
  const [options, setOptions] = useState([]);
  
  useEffect(() => {
    async function retriveData() {
      const results = await getData(query);
      if (results) setOptions(results);
    }

    if (query !== '') {
      retriveData();
    } else {
      setOptions([]);
    }
  }, [query, getData]);

  const handleSelect = (value) => {
    // Verifica se l'elemento è già selezionato
    if (selectedValues.some(item => getId(item) === getId(value))) {
      // Se selezionato, deseleziona
      handleDeselect(value);
    } else {
      // Altrimenti seleziona
      onChange([...selectedValues, value]);
    }
  };

  const handleDeselect = (value) => {
    onChange(selectedValues.filter(item => getId(item) !== getId(value)));
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setQuery(value);
  };

  return (
    <div>
      <Combobox as="div" value={selectedValues} onChange={handleSelect}>
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none sm:text-sm">
            <Combobox.Input 
              className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
              displayValue={(element) => (element ? getDisplay(element) : '')}
              onChange={handleInputChange}
              placeholder={placeholder}
            />
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full z-40 overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              style={{ position: 'absolute', zIndex: '200' }}
            >
              {options.map((resource) => (
                <Combobox.Option
                  key={getId(resource)}
                  value={resource}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                      selectedValues.some(item => getId(item) === getId(resource))
                        ? 'bg-indigo-200 text-gray-700'
                        : active
                        ? 'bg-indigo-100 text-gray-700'
                        : 'text-gray-900'
                    }`
                  }
                >
                  {getDisplay(resource)}
                </Combobox.Option>
              ))}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}

export default ComboboxMultiSelectAPI;
